import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/dataContext";
import { useParams, Link } from "react-router-dom";
import ImageChanger from "../../components/admin/ImageChanger";
import RenderIf from "../../components/RenderIf";
import Carging from "../../components/Carging";
import { useNavigate } from "react-router-dom";
import Galery from "../../components/admin/Galery";


const EditWork = () => {

    const { getDataById, saveDataByid } = useContext(DataContext);
    const [work, setWork] = useState(null);
    const { id } = useParams();
    const [isCarging, setIsCarging] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            getDataById(id)
                .then(res => {
                    setWork(res);
                })
        } else {
            setWork({
                title: "",
                description: "",
                image: "",
                galeria: [],
                tags: "",
                Link: ""

            });
        }

    }, [id])

    if (work === null) {
        return <div>Loading...</div>

    }

    const changeWork = (e) => {
        setWork({
            ...work,
            [e.target.name]: e.target.value
        })
    }

    const handdleSubmit = (e) => {
        e.preventDefault();
        setIsCarging(true);
        saveDataByid(work)
            .then(res => {
                setIsCarging(false);
                navigate(`/admin/portafolio/${id  ? id  : ''}`);
            })

    }

    return (

        <form
            onSubmit={(e) => handdleSubmit(e)}
            className="h-100 d-flex w-100"
        >
            <div className="col-md-6 h-75 me-2">
                <div className="card h-100 w-100" >
                    <ImageChanger
                        image={work?.image}
                        name="img"
                        onChange={(e) => {
                            changeWork(e)
                        }}
                    />
                    <div className="w-100 h-25">
                        <Galery list={work?.galeria} onChange={changeWork} />
                    </div>

                </div>
            </div>

            <div className="h-75 col-md-5 me-2">
                <div className="card h-100  w-100 p-5">
                    <div className="form-floating mb-3">
                        <input
                            value={work.title}
                            onChange={(e) => {
                                changeWork(e)
                            }}

                            type="text"
                            className="form-control"
                            name="title"
                            placeholder="Awsome Title" />
                        <label htmlFor="floatingInput">Title</label>
                    </div>

                    <div className="form-floating mb-5">
                        <textarea
                            value={work.description}
                            onChange={(e) => {
                                changeWork(e)
                            }}
                            className="form-control"
                            placeholder="Leave a comment here"
                            style={{ height: "100px" }}
                            name="description">
                        </textarea>
                        <label htmlFor="description">Description</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={work.tags}
                            onChange={(e) => {
                                changeWork(e)
                            }}

                            type="text"
                            className="form-control"
                            name="tags"
                            placeholder="REACT, HTML" />
                        <label htmlFor="floatingInput">Tags</label>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            value={work.Link}
                            onChange={(e) => {
                                changeWork(e)
                            }}

                            type="text"
                            className="form-control"
                            name="Link"
                            placeholder="https://www.gabrielpacheco.com" />
                        <label htmlFor="floatingInput">Link</label>
                    </div>
                </div>
            </div>
            <div className="col-md-1 d-flex flex-column">
                <Link to={`/admin/portafolio/${id || ''} `} className="btn bg-white">
                    <i className="bi bi-arrow-left"></i>
                </Link>
                <button type="submit" className="btn bg-white">
                    <RenderIf condition={isCarging} >
                        <Carging />
                    </RenderIf>

                    <RenderIf condition={!isCarging} >
                        <i className="bi bi-cloud-arrow-up">
                        </i>
                    </RenderIf>
                </button>
            </div>
        </form>
    )


}
export default EditWork;